import React from 'react';

interface LabelingMethodSelectorProps {
  labelingMethod: string;
  onMethodChange: (method: string) => void;
  columns: any[];
  labelColumn: string;
  onLabelColumnChange: (column: string) => void;
  labelValues: any[];
  onClassificationChange: (index: number, classification: string) => void;
}

export const LabelingMethodSelector: React.FC<LabelingMethodSelectorProps> = ({
  labelingMethod,
  onMethodChange,
  columns,
  labelColumn,
  onLabelColumnChange,
  labelValues,
  onClassificationChange
}) => {
  return (
    <div className="p-4 border border-slate-600 rounded-lg bg-slate-800">
      <h3 className="text-white font-medium mb-4">Label Selection Method</h3>
      <p className="text-slate-400 text-sm">
        Label selection functionality will be implemented here.
      </p>
      <div className="mt-4">
        <select 
          value={labelColumn} 
          onChange={(e) => onLabelColumnChange(e.target.value)}
          className="bg-slate-700 text-white rounded px-3 py-2"
        >
          <option value="">Select a column...</option>
          {columns.map(col => (
            <option key={col.name} value={col.name}>{col.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
}; 